module.exports = __webpack_public_path__ + "models/tutor4.7709ed2.txt";